<template>
	<div class="card card-devices mb-2" v-show="!hideItem">
		<div class="card-content">
			<p><b>Device: </b>{{ item.ua }}</p>
			<p><b>Last Login: </b> {{ item.last_login | formatDate }}</p>
			<el-tag type="info" v-if="item.current">Current Device</el-tag>
			<el-button v-else @click="removeDevice()" type="danger">Remove</el-button>
		</div>
	</div>
</template>

<script>
	import ListItem from '../mixins/base-list-item';
	import Http from '../mixins/http';

	export default{
		mixins: [ListItem, Http],

		data() {
			return {
				hideItem: false
			}
		},

		methods: {

			/**
			 * Remove a device...
			 */
			removeDevice() {
				this.$confirm('This will log you out of the device. Continue?', 'Warning', {
					confirmButtonText: 'OK',
					cancelButtonText: 'Cancel',
					type: 'warning'
				}).then(() => {
					this.sendRequest('/api/user-devices/remove/' + this.item.id, 'post', this.deviceRemoved)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: 'Device removal canceled'
					});
				});
			},

			/**
			 * Hide device from view...
			 *
			 * @param data
			 * @param message
			 */
			deviceRemoved(data, message) {
				this.hideItem = data;
				this.$message({
					type: message.type,
					message: message.content
				});
			}
		}
	}
</script>
